/* PIRANGA size tools: How to measure guide and Find your perfect size. Reads the product's own size chart; answers stay in the shopper's browser. */
(function () {
  var KEY = 'piranga:fit';
  var LINE = 'fill="none" stroke="#000" stroke-width="1.1" stroke-linejoin="round" stroke-linecap="round"';
  var SEAM = 'fill="none" stroke="#000" stroke-width=".6"';
  var RULE = 'fill="none" stroke="#000" stroke-width=".7"';
  var HAIR = 'fill="none" stroke="#bbb" stroke-width=".6"';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function label(x, y, text, anchor) {
    return text.split('|').map(function (line, n) { return '<text x="' + x + '" y="' + (y + n * 19) + '" text-anchor="' + (anchor || 'middle') + '" font-size="15" letter-spacing="1.4">' + line + '</text>'; }).join('');
  }
  // a measuring line with a short stop at each end
  function dim(x1, y1, x2, y2) {
    var dx = x2 - x1, dy = y2 - y1, n = Math.sqrt(dx * dx + dy * dy), tx = -dy / n * 4, ty = dx / n * 4;
    return '<path ' + RULE + ' d="M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + 'M' + (x1 + tx) + ' ' + (y1 + ty) + 'L' + (x1 - tx) + ' ' + (y1 - ty) + 'M' + (x2 + tx) + ' ' + (y2 + ty) + 'L' + (x2 - tx) + ' ' + (y2 - ty) + '"/>';
  }
  function art(box, name, parts) { return '<svg viewBox="' + box + '" role="img" aria-label="' + name + ' measured flat">' + parts + '</svg>'; }
  var TOP_ROWS = function (edge, end) {
    return [['Chest Width', 'Lay it flat. Measure straight across, 1" below the armholes, from side to side.'], ['Front Length', 'From the top of the shoulder beside the ' + edge + ', straight down to the hem.'], ['Sleeve Length', 'From the shoulder seam to the ' + end + '.'], ['Shoulder Width', 'Along the top of the shoulder, from the ' + edge + ' to the shoulder seam.']];
  };
  var BOTTOM_ROWS = [['Waist', 'Lay it flat without stretching. Measure straight across the top edge.'], ['Front Rise', 'Straight down from the top edge of the waist to the crotch seam.'], ['Inseam', 'Along the inner leg, from the crotch seam to the hem.'], ['Leg Opening', 'Straight across the bottom of the leg, lying flat.']];
  var LONG_SLEEVE = '<path ' + SEAM + ' d="M138 250H282M87 216 117 222M333 216 303 222"/>' +
    dim(248, 42, 300, 58) + label(304, 47, 'SHOULDER', 'start') +
    '<path ' + HAIR + ' d="M286 262H362M260 58H362"/>' + dim(356, 58, 356, 262) + label(366, 156, 'FRONT|LENGTH', 'start') +
    dim(110, 70, 70, 222) + label(62, 140, 'SLEEVE|LENGTH', 'end') +
    dim(138, 124, 282, 124) + label(210, 118, 'CHEST');
  var LONG_BODY = 'M176 58 124 74 84 226 114 232 138 112V262H282V112L306 232 336 226 296 74 244 58';
  var WAISTBAND = '<path ' + SEAM + ' d="M150 36H270M210 36V112M204 36Q202 48 197 56M216 36Q218 48 223 56"/>';
  var GUIDE = {
    tees: {
      name: 'T-Shirts',
      art: art('0 0 420 262', 'T-shirt', '<path ' + LINE + ' d="M180 44Q210 66 240 44L292 60 340 128 304 146 282 104V232H138V104L116 146 80 128 128 60ZM180 44Q210 36 240 44"/><path ' + SEAM + ' d="M175 46Q210 76 245 46M128 60Q140 84 138 104M292 60Q280 84 282 104M138 225H282M85 121 119 139M335 121 301 139"/>' +
        dim(244, 30, 296, 46) + label(300, 34, 'SHOULDER', 'start') +
        '<path ' + HAIR + ' d="M286 232H362M246 44H362"/>' + dim(356, 44, 356, 232) + label(366, 134, 'FRONT|LENGTH', 'start') +
        dim(118, 53, 70, 121) + label(62, 76, 'SLEEVE|LENGTH', 'end') +
        dim(138, 116, 282, 116) + label(210, 110, 'CHEST')),
      rows: TOP_ROWS('collar', 'sleeve edge')
    },
    hoodies: {
      name: 'Hoodies',
      art: art('0 0 420 290', 'Hoodie', '<path ' + LINE + ' d="M176 58Q170 12 210 10 250 12 244 58Q210 84 176 58' + LONG_BODY + '"/><path ' + SEAM + ' d="M188 62Q190 28 210 26 230 28 232 62M200 72V110M220 72V110M168 204H252L268 236V250H152V236Z"/>' + LONG_SLEEVE),
      rows: TOP_ROWS('hood', 'end of the cuff')
    },
    crews: {
      name: 'Crewnecks & Jackets',
      art: art('0 22 420 268', 'Crewneck', '<path ' + LINE + ' d="M176 58Q210 44 244 58Q210 84 176 58' + LONG_BODY + '"/><path ' + SEAM + ' d="M171 60Q210 92 249 60"/>' + LONG_SLEEVE),
      rows: TOP_ROWS('collar', 'end of the cuff')
    },
    pants: {
      name: 'Sweatpants & Pants',
      art: art('0 -22 420 362', 'Pants', '<path ' + LINE + ' d="M150 20H270V36L292 150 282 290V306H234V290L212 130H208L186 290V306H138V290L128 150 150 36Z"/>' + WAISTBAND + '<path ' + SEAM + ' d="M138 290H186M234 290H282M154 44 170 86M266 44 250 86"/>' +
        dim(150, 8, 270, 8) + label(210, -2, 'WAIST') +
        '<path ' + HAIR + ' d="M274 20H312M212 130H312"/>' + dim(306, 20, 306, 130) + label(316, 72, 'FRONT|RISE', 'start') +
        '<path ' + HAIR + ' d="M208 130H100M138 306H100"/>' + dim(106, 130, 106, 306) + label(96, 220, 'INSEAM', 'end') +
        dim(234, 318, 282, 318) + label(258, 338, 'LEG OPENING')),
      rows: BOTTOM_ROWS
    },
    shorts: {
      name: 'Shorts',
      art: art('0 -22 420 270', 'Shorts', '<path ' + LINE + ' d="M150 20H270V36L300 200 222 208 212 120H208L198 208 120 200 150 36Z"/>' + WAISTBAND + '<path ' + SEAM + ' d="M122 191 199 199M221 199 298 191M154 44 168 82M266 44 252 82"/>' +
        dim(150, 8, 270, 8) + label(210, -2, 'WAIST') +
        '<path ' + HAIR + ' d="M274 20H322M212 120H322"/>' + dim(316, 20, 316, 120) + label(326, 67, 'FRONT|RISE', 'start') +
        '<path ' + HAIR + ' d="M208 120H94M120 204H94"/>' + dim(100, 120, 100, 204) + label(90, 165, 'INSEAM', 'end') +
        dim(222, 220, 300, 212) + label(262, 241, 'LEG OPENING')),
      rows: BOTTOM_ROWS
    }
  };

  function productData() {
    var el = $('script[id^="ProductJson-"]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function category() {
    var p = productData(), title = (p ? p.title : document.title).toLowerCase();
    if (/short/.test(title)) return 'shorts';
    if (/pant|jogger|trouser|jean/.test(title)) return 'pants';
    if (/hood|sweat|crew|zip|fleece|varsity/.test(title)) return 'hoodies';
    return 'tees';
  }
  // How this product is cut, as worked out by snippets/piranga-fit-type.liquid and shown under the size chart.
  function cut() {
    var el = $('[data-pi-cut]');
    return el ? { key: el.getAttribute('data-pi-cut'), name: el.getAttribute('data-pi-cut-name') } : { key: '', name: '' };
  }
  function guideKey() {
    var p = productData(), title = (p ? p.title : document.title).toLowerCase(), kind = category();
    if (/\bcap\b|\bhat\b|beanie/.test(title)) return null;
    return kind === 'hoodies' && /crew|varsity/.test(title) ? 'crews' : kind;
  }

  /* ---------- the guide ---------- */
  function dialog(cls) {
    var d = document.createElement('dialog');
    d.className = cls;
    document.body.appendChild(d);
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-pi-close]')) d.close();
    });
    d.addEventListener('close', function () { d.parentNode.removeChild(d); });
    d.showModal();
    return d;
  }
  var CLOSE = '<button type="button" class="pi-close" data-pi-close aria-label="Close"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#000"><path d="M1 1l14 14M15 1L1 15"/></svg></button>';
  function openGuide() {
    var d = dialog('pi-guide');
    d.innerHTML = CLOSE + '<div class="pi-guide__inner"></div>';
    buildGuide($('.pi-guide__inner', d), '<p class="pi-guide__note">All Piranga measurements are garment measurements, taken flat. For the easiest comparison, measure a piece you already love the same way.</p>');
  }
  // The list opens over the drawing with the current type on top, so it stays one tap to change.
  function buildGuide(box, note) {
    var at = guideKey() || 'tees';
    box.innerHTML = '<h2>How to measure guide</h2><div class="pi-guide__pick"><button type="button" class="pi-guide__select" aria-haspopup="listbox" aria-expanded="false"><span></span></button><div class="pi-guide__list" role="listbox" hidden></div></div><div class="pi-guide__art"></div><div class="pi-guide__rows"></div>' + (note || '');
    var button = $('.pi-guide__select', box), list = $('.pi-guide__list', box);
    function toggle(open) {
      list.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function paint() {
      var g = GUIDE[at];
      $('span', button).textContent = g.name;
      list.innerHTML = Object.keys(GUIDE).filter(function (k) { return k !== at; }).map(function (k) { return '<button type="button" role="option" data-pi-kind="' + k + '">' + GUIDE[k].name + '</button>'; }).join('');
      $('.pi-guide__art', box).innerHTML = g.art;
      $('.pi-guide__rows', box).innerHTML = g.rows.map(function (r) { return '<h3>' + r[0] + '</h3><p>' + r[1] + '</p>'; }).join('');
    }
    box.addEventListener('click', function (e) {
      var kind = e.target.closest('[data-pi-kind]');
      if (kind) { at = kind.getAttribute('data-pi-kind'); paint(); toggle(false); button.focus(); }
      else if (e.target.closest('.pi-guide__select')) toggle(list.hidden);
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) { e.stopPropagation(); toggle(false); button.focus(); }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.pi-guide__pick') || !box.contains(e.target)) toggle(false); });
    paint();
  }

  /* ---------- the size chart ---------- */
  // Some charts sit under the wrong Inches / Centimeters tab, so the unit comes from the numbers: no chest is under 40 cm flat and no waist under 50 cm.
  function readChart() {
    var seen = {};
    $$('.size-chart-wrapper table').forEach(function (table) {
      var rows = $$('tr', table).map(function (tr) { return $$('th,td', tr).map(function (c) { return c.textContent.trim(); }); });
      if (rows.length < 2) return;
      var sizes = rows[0].slice(1), m = {};
      rows.slice(1).forEach(function (r) {
        var key = /chest/i.test(r[0]) ? 'chest' : /waist/i.test(r[0]) ? 'waist' : /length/i.test(r[0]) && /front/i.test(r[0]) ? 'length' : /inseam/i.test(r[0]) ? 'inseam' : null;
        if (key) m[key] = r.slice(1).map(Number);
      });
      var anchor = m.chest || m.waist;
      if (!anchor || anchor.some(isNaN)) return;
      var factor = anchor[0] < (m.chest ? 40 : 50) ? 2.54 : 1;
      Object.keys(m).forEach(function (k) { m[k] = m[k].map(function (v) { return v * factor; }); });
      var id = Math.round(anchor[0] * factor);
      seen[id] = seen[id] || { sizes: sizes, m: m, votes: 0 };
      seen[id].votes++;
    });
    return Object.keys(seen).map(function (k) { return seen[k]; }).sort(function (a, b) { return b.votes - a.votes; })[0] || null;
  }

  // The product decides what is shown. A bottom whose chart was copied from a top (no waist row) falls back to the regular chart for that type.
  var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var STANDARD = {
    pants: { sizes: SIZES, standard: true, m: { waist: [68.6, 73.7, 78.7, 83.8, 88.9, 94], inseam: [77.5, 77.5, 78.7, 78.7, 78.7, 80] } },
    shorts: { sizes: SIZES, standard: true, m: { waist: [76.2, 83.8, 88.9, 96.5, 101.6, 109.2], inseam: [36.8, 36.8, 36.8, 36.8, 36.8, 36.8] } }
  };
  function chartFor() {
    var chart = readChart(), kind = category();
    if (STANDARD[kind] && !(chart && chart.m.waist)) return STANDARD[kind];
    return chart;
  }

  /* ---------- the recommendation ---------- */
  // Body sizes are rough averages from height and weight, centred on these people, then moved by the shape answers
  var BASE = {
    men: { cm: 176, kg: 85, chest: 106, waist: 94, hips: 102, inseam: 0.45, startCm: 178, startKg: 78 },
    women: { cm: 163, kg: 68, chest: 96, waist: 82, hips: 102, inseam: 0.44, startCm: 165, startKg: 60 }
  };
  var SHIFT = { narrower: -4, average: 0, fuller: 5 };
  var TARGET = { top: { closer: 8, design: 14, roomy: 22 }, bottom: { closer: 0, design: 3, roomy: 7 } };
  var STRETCH = 14;   // what an elastic waist gives

  function estimate(a) {
    var b = BASE[a.sex], kg = a.kg - b.kg, cm = a.cm - b.cm;
    return {
      chest: b.chest + 0.6 * kg - 0.15 * cm + SHIFT[a.chest],
      waist: b.waist + 0.85 * kg - 0.3 * cm + SHIFT[a.belly],
      hips: b.hips + 0.7 * kg - 0.1 * cm + SHIFT[a.hips],
      inseam: a.cm * b.inseam
    };
  }
  // Tops are cut oversized on purpose, so ease alone would always point to the smallest size.
  // Instead we find the shopper's usual size from their body, then the fit answer moves it one size down or up.
  var BODY_CHEST = {
    men: [['XXS', 84], ['XS', 89], ['S', 95], ['M', 102], ['L', 109], ['XL', 117], ['XXL', 999]],
    // Our sizes are unisex, so women use the same scale on their bust, which already lands them a size below men of the same height.
    women: [['XXS', 84], ['XS', 89], ['S', 95], ['M', 102], ['L', 109], ['XL', 117], ['XXL', 999]]
  };
  var FIT_STEP = { closer: -1, design: 0, roomy: 1 };
  var DESIGNED = { oversized: 'Oversized, the way we cut it', boxy: 'Boxy, wide and slightly cropped', relaxed: 'Relaxed, easy room', regular: 'Regular, true to size' };
  var CUT_NOTE = { oversized: 'This piece is cut oversized, so your usual size already gives a roomy look.', boxy: 'This piece is cut boxy, wide and slightly cropped, so your usual size already gives the intended shape.', relaxed: 'This piece has a relaxed cut, with easy room but not oversized.', regular: 'This piece has a regular, true-to-size cut.' };
  function usualSize(sex, chest) {
    var list = BODY_CHEST[sex], i = 0;
    while (i < list.length - 1 && chest >= list[i][1]) i++;
    var edge = Math.min(Math.abs(chest - (list[i - 1] ? list[i - 1][1] : -99)), Math.abs(list[i][1] - chest));
    var near = chest - (list[i - 1] ? list[i - 1][1] : -99) < list[i][1] - chest ? i - 1 : i + 1;
    return { name: list[i][0], at: i, edge: edge, near: list[near] ? list[near][0] : null, list: list };
  }
  function indexIn(chart, name, list) {
    var i = chart.sizes.indexOf(name);
    if (i >= 0) return i;
    var want = list.map(function (x) { return x[0]; }).indexOf(name);
    var best = 0, gap = 99;
    chart.sizes.forEach(function (s, k) { var at = list.map(function (x) { return x[0]; }).indexOf(s); if (at >= 0 && Math.abs(at - want) < gap) { gap = Math.abs(at - want); best = k; } });
    return best;
  }
  function recommend(chart, a) {
    var body = estimate(a), top = !!chart.m.chest, fit = FIT_STEP.hasOwnProperty(a.fit) ? a.fit : 'design';
    var step = FIT_STEP[fit] + (cut().key === 'regular' && fit === 'closer' ? 1 : 0);
    var need = top ? Math.max(body.chest, body.waist + 6) : Math.max(body.waist, body.hips - 12);
    var room = chart.sizes.map(function (s, i) { return (top ? chart.m.chest[i] * 2 : chart.m.waist[i] + STRETCH) - need; });
    var last = room.length - 1, r;
    if (top) {
      var usual = usualSize(a.sex, need), base = indexIn(chart, usual.name, usual.list);
      var pick = Math.max(0, Math.min(last, base + step));
      r = { top: true, body: body, room: room, target: room[base], verdict: 'best', pick: pick };
      if (base + step > last) r.verdict = 'tight';
      else if (base + step < 0) r.verdict = 'loose';
      else if (usual.edge <= 1.5 && usual.near) {
        var other = indexIn(chart, usual.near, usual.list) + step;
        if (other !== pick && other >= 0 && other <= last) { r.verdict = 'between'; r.other = other; }
      }
      return r;
    }
    var target = TARGET.bottom[fit], i = 0;
    while (i < room.length && room[i] < target) i++;
    r = { top: false, body: body, room: room, target: target, verdict: 'best', pick: i };
    if (i === room.length) { r.pick = last; r.verdict = 'tight'; }
    else if (i === 0 && room[0] > target + 14) r.verdict = 'loose';
    else if (i > 0 && target - room[i - 1] <= 2) { r.verdict = 'between'; r.other = i - 1; }
    return r;
  }

  /* ---------- stock and the size buttons ---------- */
  function sizeOption(p) {
    var at = -1;
    (p.options || []).forEach(function (o, i) { if (/size/i.test(typeof o === 'string' ? o : o.name)) at = i; });
    return at;
  }
  function variantFor(size) {
    var p = productData(), at = p ? sizeOption(p) : -1;
    if (at < 0) return null;
    var form = $('form.piranga-guarded-form');
    return p.variants.filter(function (v) {
      return v.options[at] === size && v.options.every(function (value, i) {
        if (i === at || !form) return true;
        var picked = $('input[name="option' + (i + 1) + '"]:checked', form);
        return !picked || picked.value === value;
      });
    })[0] || null;
  }
  function inStock(size) { var v = variantFor(size); return !!(v && v.available); }
  function nearestInStock(chart, i) {
    for (var d = 1; d < chart.sizes.length; d++) {
      if (chart.sizes[i + d] && inStock(chart.sizes[i + d])) return chart.sizes[i + d];
      if (chart.sizes[i - d] && inStock(chart.sizes[i - d])) return chart.sizes[i - d];
    }
    return null;
  }
  function chooseSize(size) {
    var p = productData(), at = p ? sizeOption(p) : -1;
    var input = at < 0 ? null : $$('form.piranga-guarded-form input[name="option' + (at + 1) + '"]').filter(function (el) {
      return el.value === size && !el.closest('.fixed-variant_image');
    })[0];
    if (input) input.click();
  }

  /* ---------- the figure: the shopper to scale, wearing the garment ---------- */
  function garment() {
    var c = category();
    if (c === 'tees') return 'tee';
    if (c === 'hoodies') return /hood/i.test(productData().title) ? 'hoodie' : 'sweatshirt';
    return c;
  }
  var SHADES = [[/white|cream|ivory|ecru|bone/, '#f4f1ea'], [/black|onyx/, '#1a1a1a'], [/navy/, '#1f2a44'], [/blue|denim|indigo/, '#4f6d8f'], [/brick|rust/, '#9c4034'], [/red|burgundy|maroon|wine/, '#8f2525'], [/rose|pink|blush/, '#c79a98'], [/purple|lilac|mist|lavender/, '#a895ad'], [/green|olive|sage|moss/, '#66705a'], [/yellow|mustard/, '#e3c65a'], [/orange/, '#d8743a'], [/brown|coffee|mocha|chocolate/, '#6b4a35'], [/beige|sand|tan|khaki|stone/, '#cdbda3'], [/grey|gray|charcoal|ash/, '#858585']];
  function colourOf() {
    var p = productData(), at = -1;
    ((p && p.options) || []).forEach(function (o, i) { if (/colou?r/i.test(typeof o === 'string' ? o : o.name)) at = i; });
    var picked = at < 0 ? null : $('form.piranga-guarded-form input[name="option' + (at + 1) + '"]:checked');
    var name = picked ? picked.value.toLowerCase() : '', hit = SHADES.filter(function (x) { return x[0].test(name); })[0];
    return hit ? hit[1] : '#3a3a3a';
  }
  function isDark(hex) {
    var v = parseInt(hex.slice(1), 16);
    return ((v >> 16) * 299 + ((v >> 8) & 255) * 587 + (v & 255) * 114) / 1000 < 128;
  }
  // shapes glide to their new form: the paths keep their structure, so only the attributes change (browsers without path animation just switch)
  function morph(stage, html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var from = $$('path,circle', stage), to = $$('path,circle', box);
    if (!from.length || from.length !== to.length) { stage.innerHTML = html; return; }
    from.forEach(function (el, i) {
      ['d', 'cx', 'cy', 'r', 'fill', 'stroke'].forEach(function (k) {
        if (to[i].hasAttribute(k)) el.setAttribute(k, to[i].getAttribute(k));
      });
    });
  }
  function figure(chart, a, r, i) {
    var body = r.body, s = 1.02, H = a.cm * s, foot = 236, head = foot - H, cx = 70;
    function y(p) { return (head + H * p).toFixed(1); }
    function n(v) { return v.toFixed(1); }
    var woman = a.sex === 'women';
    var chest = body.chest * 0.16 * s, waist = body.waist * (woman ? 0.14 : 0.16) * s, hips = body.hips * (woman ? 0.175 : 0.155) * s, shoulder = chest * (woman ? 0.92 : 1.12);
    // men carry more through the leg: fuller thigh, knee and calf
    var legs = woman ? [[hips * 0.9, 0.6], [hips * 0.6, 0.76], [hips * 0.56, 0.84], [hips * 0.36, 0.965]] : [[hips * 0.98, 0.6], [hips * 0.8, 0.76], [hips * 0.78, 0.84], [hips * 0.56, 0.965]];
    var side = [[shoulder, 0.19], [chest, 0.28], [waist, 0.4], [hips, 0.5]].concat(legs);
    var inner = [[2.5, 0.965], [2.5, 0.76], [0, 0.52]];
    var points = side.concat(inner);
    var left = points.map(function (q) { return n(cx - q[0]) + ' ' + y(q[1]); });
    var right = points.slice().reverse().map(function (q) { return n(cx + q[0]) + ' ' + y(q[1]); });
    // chunky thick-soled sneakers ground the wide leg
    var toe = hips * (woman ? 0.36 : 0.56) + (woman ? 3 : 6), upper = foot - (woman ? 8 : 11), sole = foot - (woman ? 2.5 : 4.5);
    function shoe(way) {
      var e = cx + way * toe, b = cx + way * 1.5, c = cx + way * (toe - 4);
      return 'M' + n(b) + ' ' + n(upper) + 'L' + n(c) + ' ' + n(upper) + 'Q' + n(e) + ' ' + n(upper) + ' ' + n(e) + ' ' + n(sole) + 'L' + n(e) + ' ' + foot + 'L' + n(b) + ' ' + foot + 'Z';
    }
    var shoes = '<path d="' + shoe(-1) + shoe(1) + '" fill="#fff" stroke="#000" stroke-width="1.2" stroke-linejoin="round"/>' +
      '<path d="M' + n(cx - toe) + ' ' + n(sole) + 'L' + n(cx - 1.5) + ' ' + n(sole) + 'M' + n(cx + 1.5) + ' ' + n(sole) + 'L' + n(cx + toe) + ' ' + n(sole) + '" fill="none" stroke="#000" stroke-width="1"/>';
    var r0 = H * 0.062, neck = '<path d="M' + n(cx - 3.5) + ' ' + y(0.11) + 'V' + y(0.195) + 'H' + n(cx + 3.5) + 'V' + y(0.11) + 'Z" fill="#fff" stroke="#000" stroke-width="1.2"/>';
    var hair = woman ? '<path d="M' + n(cx - r0) + ' ' + y(0.075) + 'A' + n(r0) + ' ' + n(r0) + ' 0 0 1 ' + n(cx + r0) + ' ' + y(0.075) + 'Q' + n(cx) + ' ' + y(0.03) + ' ' + n(cx - r0) + ' ' + y(0.075) + 'Z" fill="#000"/><path d="M' + n(cx - r0 - 0.5) + ' ' + y(0.06) + 'Q' + n(cx - r0 - 4) + ' ' + y(0.12) + ' ' + n(cx - r0 - 1) + ' ' + y(0.165) + 'M' + n(cx + r0 + 0.5) + ' ' + y(0.06) + 'Q' + n(cx + r0 + 4) + ' ' + y(0.12) + ' ' + n(cx + r0 + 1) + ' ' + y(0.165) + '" fill="none" stroke="#000" stroke-width="3.5" stroke-linecap="round"/>' : '';
    var person = neck + shoes + '<circle cx="' + cx + '" cy="' + y(0.065) + '" r="' + n(r0) + '" fill="#fff" stroke="#000" stroke-width="1.2"/>' + hair +
      '<path d="M' + left.join('L') + 'L' + right.join('L') + 'Z" fill="#fff" stroke="#000" stroke-width="1.2" stroke-linejoin="round"/>' +
      '<path d="M' + n(cx - shoulder) + ' ' + y(0.2) + 'L' + n(cx - shoulder - 9) + ' ' + y(0.5) + 'M' + n(cx + shoulder) + ' ' + y(0.2) + 'L' + n(cx + shoulder + 9) + ' ' + y(0.5) + '" fill="none" stroke="#000" stroke-width="3" stroke-linecap="round"/>';
    var extra = Math.max(r.room[i], 0) * 0.16 * s * 1.6, kind = garment(), shade = colourOf();
    var ink = isDark(shade) ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.5)', cloth, lines, behind = '';
    function mirror(list) {
      var l = list.map(function (q) { return n(cx - q[0]) + ' ' + n(q[1]); });
      var r2 = list.slice().reverse().map(function (q) { return n(cx + q[0]) + ' ' + n(q[1]); });
      return 'M' + l.join('L') + 'L' + r2.join('L') + 'Z';
    }
    if (r.top) {
      var wide = chest + extra, sh = Math.max(shoulder, wide * 0.96), yS = head + H * 0.185, hem = yS + chart.m.length[i] * s;
      var long = kind !== 'tee', cuffY = long ? head + H * 0.5 : yS + 32, cuffX = sh + (long ? 14 : 13);
      cloth = mirror([[6, yS - 3], [sh, yS], [cuffX, cuffY], [cuffX - 11, cuffY + 3], [wide, yS + 28], [wide, hem]]);
      lines = 'M' + n(cx - 7) + ' ' + n(yS - 2) + 'Q' + cx + ' ' + n(yS + 7) + ' ' + n(cx + 7) + ' ' + n(yS - 2);
      if (long) {
        lines += 'M' + n(cx - wide) + ' ' + n(hem - 5) + 'H' + n(cx + wide) +
          'M' + n(cx - cuffX + 1) + ' ' + n(cuffY - 6) + 'L' + n(cx - cuffX + 12) + ' ' + n(cuffY - 3) +
          'M' + n(cx + cuffX - 1) + ' ' + n(cuffY - 6) + 'L' + n(cx + cuffX - 12) + ' ' + n(cuffY - 3);
      }
      if (kind === 'hoodie') {
        behind = '<path d="M' + n(cx - 11) + ' ' + n(yS + 2) + 'Q' + n(cx - r0 - 7) + ' ' + y(0.055) + ' ' + cx + ' ' + y(0.002) + 'Q' + n(cx + r0 + 7) + ' ' + y(0.055) + ' ' + n(cx + 11) + ' ' + n(yS + 2) + 'Z" fill="' + shade + '" stroke="#000" stroke-width="1"/>';
        var pocket = wide * 0.58, pocketTop = hem - 26;
        lines += 'M' + n(cx - pocket) + ' ' + n(hem - 5) + 'L' + n(cx - pocket * 0.7) + ' ' + n(pocketTop) + 'H' + n(cx + pocket * 0.7) + 'L' + n(cx + pocket) + ' ' + n(hem - 5) +
          'M' + n(cx - 3) + ' ' + n(yS + 3) + 'V' + n(yS + 22) + 'M' + n(cx + 3) + ' ' + n(yS + 3) + 'V' + n(yS + 22);
      }
    } else {
      var shorts = kind === 'shorts', wa = waist + extra, crotch = head + H * 0.52, top = head + H * 0.42;
      var inseam = chart.m.inseam ? chart.m.inseam[i] : (shorts ? 18 : 76);
      var ankle = Math.min(upper + 2, crotch + inseam * s), hip = Math.max(wa, hips + 2);
      var knee = shorts ? hips * (woman ? 0.9 : 1.1) : Math.max(wa * (woman ? 0.72 : 0.92), hips * (woman ? 0.74 : 1)), leg = shorts ? knee : hips * (woman ? 0.5 : 0.72);
      var mid = shorts ? crotch + (ankle - crotch) * 0.5 : Math.min(ankle - 12, head + H * 0.78);
      cloth = 'M' + n(cx - wa) + ' ' + n(top) + 'L' + n(cx + wa) + ' ' + n(top) + 'L' + n(cx + hip) + ' ' + y(0.5) + 'L' + n(cx + knee) + ' ' + n(mid) + 'L' + n(cx + leg) + ' ' + n(ankle) + 'L' + n(cx + 2) + ' ' + n(ankle) + 'L' + cx + ' ' + n(crotch) + 'L' + n(cx - 2) + ' ' + n(ankle) + 'L' + n(cx - leg) + ' ' + n(ankle) + 'L' + n(cx - knee) + ' ' + n(mid) + 'L' + n(cx - hip) + ' ' + y(0.5) + 'Z';
      lines = 'M' + n(cx - wa) + ' ' + n(top + 6) + 'H' + n(cx + wa) + 'M' + n(cx - 3) + ' ' + n(top + 6) + 'V' + n(top + 20) + 'M' + n(cx + 3) + ' ' + n(top + 6) + 'V' + n(top + 20);
      if (!shorts) lines += 'M' + n(cx - leg) + ' ' + n(ankle - 6) + 'H' + n(cx - 2) + 'M' + n(cx + 2) + ' ' + n(ankle - 6) + 'H' + n(cx + leg);
    }
    return '<svg viewBox="0 0 140 240" role="img" aria-label="Your shape wearing size ' + esc(chart.sizes[i]) + '">' + behind + person +
      '<path d="' + cloth + '" fill="' + shade + '" stroke="#000" stroke-width="1" stroke-linejoin="round"/>' +
      '<path d="' + lines + '" fill="none" stroke="' + ink + '" stroke-width="1" stroke-linecap="round"/></svg>';
  }

  /* ---------- how each area fits ---------- */
  function clamp(v) { return Math.max(4, Math.min(96, v)); }
  function areas(chart, a, r, i, fmt) {
    function area(name, pos, words, text) {
      var word = pos < 34 ? words[0] : pos > 66 ? words[2] : words[1];
      return { name: name, pos: clamp(pos), word: word, text: text };
    }
    var snug = ['Tight', 'Just right', 'Roomy'], long = ['Short', 'Just right', 'Long'], rows = [];
    if (r.top) {
      rows.push(area('Chest', (r.room[i] - r.target + 16) / 32 * 100, snug, fmt(Math.max(0, r.room[i])) + ' of room'));
      if (chart.m.length) rows.push(area('Length', (chart.m.length[i] / a.cm - 0.37) / 0.08 * 100, long, fmt(chart.m.length[i]) + ' shoulder to hem'));
    } else {
      rows.push(area('Waist', (r.room[i] - r.target + 16) / 32 * 100, snug, fmt(chart.m.waist[i]) + ' before stretch'));
      if (chart.m.inseam) rows.push(area('Inseam', (chart.m.inseam[i] - r.body.inseam + 10) / 20 * 100, long, fmt(chart.m.inseam[i]) + ' inner leg'));
    }
    return rows;
  }

  /* ---------- the steps ---------- */
  function load() {
    var a = {};
    try { a = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
    ['chest', 'belly', 'hips'].forEach(function (k) { if (!SHIFT.hasOwnProperty(a[k])) a[k] = 'average'; });
    if (!BASE[a.sex]) a.sex = 'men';
    return a;
  }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function complete(a) { return a.cm && a.kg && a.fit; }
  function photo() {
    var img = $('.js-product-media-item:not(.piranga-off) img') || $('.js-product-media-item img');
    return img ? img.currentSrc || img.src : '';
  }
  function openFit() {
    var chart = chartFor();
    if (!chart || !chart.sizes.length) { openGuide(); return; }
    var a = load();
    var returning = complete(a);
    a.cm = a.cm || BASE[a.sex].startCm;
    a.kg = a.kg || BASE[a.sex].startKg;
    a.fit = a.fit || 'design';
    a.hu = a.hu || 'cm'; a.wu = a.wu || 'kg';
    var step = returning ? 4 : 1, view = null, moved = returning;
    var d = dialog('pi-fit');
    var p = productData();
    var price = $('.main_pro_class .title_price_main .product-price');
    var chosen = $('form.piranga-guarded-form input[name^="option"]:checked');

    function fmt(cm) { return a.hu === 'ft' ? (cm / 2.54).toFixed(1) + ' in' : Math.round(cm) + ' cm'; }
    function heightText() {
      if (a.hu === 'cm') return Math.round(a.cm) + '<small>cm</small>';
      var total = Math.round(a.cm / 2.54);
      return Math.floor(total / 12) + '&prime;' + (total % 12) + '&Prime;';
    }
    function weightText() { return (a.wu === 'kg' ? Math.round(a.kg) : Math.round(a.kg * 2.2046)) + '<small>' + a.wu + '</small>'; }
    function shell(body, foot) {
      var names = ['Your measurements', 'Your shape', 'Your fit', 'Your size'];
      d.innerHTML = CLOSE + '<div class="pi-fit__head"><h2>Size finder</h2></div>' +
        '<div class="pi-fit__item">' + (photo() ? '<img src="' + esc(photo()) + '" alt="">' : '') + '<div><strong>' + esc(p ? p.title : '') + '</strong><span>' + esc(chosen ? chosen.value : '') + (cut().name ? (chosen ? ' &middot; ' : '') + esc(cut().name) : '') + (price ? ' &middot; ' + esc(price.textContent.trim()) : '') + '</span></div></div>' +
        '<div class="pi-fit__steps">' + [1, 2, 3].map(function (n) { return '<i class="' + (n <= step ? 'is-on' : '') + '"></i>'; }).join('') + '</div>' +
        '<p class="pi-fit__where">' + (step < 4 ? 'Step ' + step + ' of 3 &middot; ' : '') + names[step - 1] + '</p>' +
        '<div class="pi-fit__body">' + body + '</div><div class="pi-fit__foot">' + foot + '<p>Your answers stay on this device. Nothing is sent anywhere.</p></div>';
    }
    function stage(i) { return '<div class="pi-stage" data-pi-stage>' + figure(chart, a, recommend(chart, a), i) + '</div>'; }
    function live() {
      return '<div class="pi-live"><span>Live estimate<em>Moves as you answer</em></span><strong data-pi-live>' + esc(chart.sizes[recommend(chart, a).pick]) + '</strong></div>';
    }
    function refresh() {
      var r = recommend(chart, a), liveEl = $('[data-pi-live]', d), stageEl = $('[data-pi-stage]', d);
      if (liveEl) liveEl.textContent = chart.sizes[r.pick];
      if (stageEl) morph(stageEl, figure(chart, a, r, r.pick));
      var h = $('[data-pi-show="h"]', d), w = $('[data-pi-show="w"]', d);
      if (h) h.innerHTML = heightText();
      if (w) w.innerHTML = weightText();
    }
    function slider(name, title, unit, list, min, max, value, show) {
      return '<div class="pi-slide"><div class="pi-slide__top"><span>' + title + '</span><div class="pi-toggle">' + list.map(function (u) {
        return '<button type="button" class="' + (u[0] === unit ? 'is-on' : '') + '" data-pi-unit="' + (name === 'cm' ? 'hu' : 'wu') + '" data-value="' + u[0] + '">' + u[1] + '</button>';
      }).join('') + '</div></div><div class="pi-slide__value" data-pi-show="' + name.charAt(0).replace('c', 'h').replace('k', 'w') + '">' + show + '</div>' +
        '<div class="pi-slide__row"><button type="button" data-pi-step="' + name + '" data-by="-1" aria-label="Less">&minus;</button><input type="range" min="' + min + '" max="' + max + '" step="1" value="' + Math.round(value) + '" data-pi-range="' + name + '" aria-label="' + title + '"><button type="button" data-pi-step="' + name + '" data-by="1" aria-label="More">+</button></div></div>';
    }
    function three(name, title, on) {
      return '<div class="pi-three"><span>' + title + '</span><div>' + [['narrower', 'Narrower'], ['average', 'Average'], ['fuller', 'Fuller']].map(function (c) {
        return '<button type="button" class="' + (on === c[0] ? 'is-on' : '') + '" data-pi-pick="' + name + '" data-value="' + c[0] + '">' + c[1] + '</button>';
      }).join('') + '</div></div>';
    }
    function nav(next) {
      return '<button type="button" class="pi-next" data-pi-next>' + next + '</button>' + (step > 1 ? '<button type="button" class="pi-back" data-pi-back>Back</button>' : '');
    }
    function paint() {
      var before = $('[data-pi-stage]', d), old = before ? before.innerHTML : null;
      draw();
      var stageNow = $('[data-pi-stage]', d);
      if (!stageNow || !old) return;
      var next = stageNow.innerHTML;
      stageNow.innerHTML = old;
      void stageNow.offsetWidth;
      morph(stageNow, next);
    }
    function draw() {
      if (step === 1) {
        shell('<h3>Let&rsquo;s find your fit</h3><p class="pi-lead">Two measurements, about ten seconds.</p>' +
          '<div class="pi-two">' + [['women', 'Women'], ['men', 'Men']].map(function (c) { return '<button type="button" class="' + (a.sex === c[0] ? 'is-on' : '') + '" data-pi-pick="sex" data-value="' + c[0] + '">' + c[1] + '</button>'; }).join('') + '</div>' +
          '<div class="pi-grid">' + stage(recommend(chart, a).pick) + '<div>' +
          slider('cm', 'Height', a.hu, [['cm', 'CM'], ['ft', 'FT/IN']], 140, 210, a.cm, heightText()) +
          slider('kg', 'Weight', a.wu, [['kg', 'KG'], ['lb', 'LB']], 40, 150, a.kg, weightText()) +
          '</div></div>' + live(), nav('Continue'));
      } else if (step === 2) {
        var top = !!chart.m.chest;
        shell('<h3>Your shape</h3><p class="pi-lead">Compared with most people your height and weight.</p><div class="pi-grid">' + stage(recommend(chart, a).pick) + '<div>' +
          (top ? three('chest', 'Chest', a.chest) : three('hips', 'Hips', a.hips)) + three('belly', 'Stomach', a.belly) +
          '</div></div>' + live(), nav('Continue'));
      } else if (step === 3) {
        shell('<h3>How do you like it to fit?</h3><p class="pi-lead">Watch the garment change on the figure.</p><div class="pi-grid">' + stage(recommend(chart, a).pick) + '<div class="pi-choices">' +
          [['closer', 'Closer', 'Neater, less room'], ['design', 'As designed', DESIGNED[cut().key] || 'The relaxed Piranga fit'], ['roomy', 'Roomier', 'Extra room, oversized']].map(function (c) {
            return '<button type="button" class="pi-choice' + (a.fit === c[0] ? ' is-on' : '') + '" data-pi-pick="fit" data-value="' + c[0] + '"><strong>' + c[1] + '</strong><span>' + c[2] + '</span></button>';
          }).join('') + '</div></div>' + live(), nav('See my size'));
      } else result();
    }
    function result() {
      paintCutNote(chart, a);
      var r = recommend(chart, a), best = r.pick, i = view === null ? best : view, size = chart.sizes[i], open = inStock(size), near = open ? null : nearestInStock(chart, i);
      var title = i !== best ? 'Comparing ' + esc(size) : esc(size);
      var tag = i !== best ? 'We suggest ' + esc(chart.sizes[best]) : { best: 'Best fit', between: 'Between ' + esc(chart.sizes[Math.min(best, r.other === undefined ? best : r.other)]) + ' and ' + esc(chart.sizes[Math.max(best, r.other === undefined ? best : r.other)]), tight: 'Our largest size, may fit close', loose: 'Our smallest size, may fit roomy' }[r.verdict];
      var chips = chart.sizes.map(function (s, n) {
        return '<button type="button" class="pi-chip' + (n === i ? ' is-on' : '') + (inStock(s) ? '' : ' is-out') + '" data-pi-view="' + n + '">' + (n === best ? '<em>You</em>' : '') + esc(s) + '</button>';
      }).join('');
      var rows = areas(chart, a, r, i, fmt).map(function (row) {
        return '<li><div><strong>' + row.name + '</strong><span>' + row.word + ' &middot; ' + row.text + '</span></div><div class="pi-meter"><i style="left:' + row.pos.toFixed(0) + '%"></i></div></li>';
      }).join('');
      shell('<div class="pi-result"><div class="pi-stage" data-pi-stage>' + figure(chart, a, r, i) + '</div><div><span class="pi-eyebrow">Your size</span><div class="pi-size">' + title + '</div><p class="pi-tag">' + tag + '</p></div></div>' +
        '<div class="pi-chips">' + chips + '</div><ul class="pi-areas">' + rows + '</ul>' +
        (open ? '' : '<p class="pi-text">' + esc(size) + ' is sold out in this colour.' + (near ? ' The nearest size in stock is ' + esc(near) + '.' : '') + '</p>') +
        (CUT_NOTE[cut().key] ? '<p class="pi-text">' + CUT_NOTE[cut().key] + '</p>' : '') + '<p class="pi-note">Based on your answers and ' + (chart.standard ? 'our standard ' + (garment() === 'shorts' ? 'shorts' : 'sweatpant') + ' measurements' : 'this product&rsquo;s size chart') + '. A guide, not a guarantee.</p>',
        (open || near ? '<button type="button" class="pi-next" data-pi-add="' + esc(open ? size : near) + '">Add size ' + esc(open ? size : near) + ' to cart</button>' : '') +
        '<div class="pi-links">' + (open || near ? '<button type="button" data-pi-select="' + esc(open ? size : near) + '">Select ' + esc(open ? size : near) + ' on the page</button>' : '') + '<button type="button" data-pi-restart>Edit details</button><button type="button" data-pi-measure>How to measure</button></div>');
      setLabel(chart.sizes[best]);
    }
    d.addEventListener('input', function (e) {
      var name = e.target.getAttribute('data-pi-range');
      if (!name) return;
      a[name] = Number(e.target.value);
      moved = true;
      refresh();
    });
    d.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-pi-unit')) { a[t.getAttribute('data-pi-unit')] = t.getAttribute('data-value'); paint(); }
      if (t.hasAttribute('data-pi-pick')) {
        a[t.getAttribute('data-pi-pick')] = t.getAttribute('data-value');
        if (t.getAttribute('data-pi-pick') === 'sex' && !moved) { a.cm = BASE[a.sex].startCm; a.kg = BASE[a.sex].startKg; }
        paint();
      }
      if (t.hasAttribute('data-pi-step')) {
        moved = true;
        var name = t.getAttribute('data-pi-step'), by = Number(t.getAttribute('data-by')), unit = name === 'cm' ? (a.hu === 'ft' ? 2.54 : 1) : (a.wu === 'lb' ? 0.4536 : 1);
        a[name] = Math.max(name === 'cm' ? 140 : 40, Math.min(name === 'cm' ? 210 : 150, a[name] + by * unit));
        var range = $('[data-pi-range="' + name + '"]', d);
        if (range) range.value = Math.round(a[name]);
        refresh();
      }
      if (t.hasAttribute('data-pi-back')) { step--; paint(); }
      if (t.hasAttribute('data-pi-next')) { step++; view = null; if (step === 4) save(a); paint(); }
      if (t.hasAttribute('data-pi-restart')) { step = 1; paint(); }
      if (t.hasAttribute('data-pi-view')) { view = Number(t.getAttribute('data-pi-view')); paint(); }
      if (t.hasAttribute('data-pi-select')) { chooseSize(t.getAttribute('data-pi-select')); d.close(); }
      if (t.hasAttribute('data-pi-add')) {
        var size = t.getAttribute('data-pi-add'), variant = variantFor(size);
        if (!variant) return;
        t.disabled = true;
        chooseSize(size);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        }).then(function () {
          d.close();
          if (window.ajaxCart) window.ajaxCart.load();
          if (window.jQuery) window.jQuery('body').trigger('drawer.open');
        }).catch(function () { t.disabled = false; });
      }
    });
    paint();
  }

  function setLabel(size) {
    var el = $('[data-pi-fit] span');
    if (el) el.textContent = 'Your size: ' + size;
  }
  // The fit note under the size chart: this product's own numbers in size M, and the shopper's size if they used the finder.
  function paintCutNote(chart, a) {
    var measure = $('[data-pi-cut-measure]'), you = $('[data-pi-cut-you]');
    if (!measure || !chart) return;
    var i = chart.sizes.indexOf('M');
    if (i < 0) i = Math.floor(chart.sizes.length / 2);
    var size = chart.sizes[i], m = chart.m, cm = function (v) { return Math.round(v) + ' cm'; };
    var text = '';
    if (m.chest) {
      var round = m.chest[i] * 2, room = round - 100;
      text = 'In size ' + size + ' this piece measures ' + cm(m.chest[i]) + ' across the chest (' + cm(round) + ' all round)' +
        (m.length ? ' and ' + cm(m.length[i]) + ' long' : '') + '. ' +
        (room >= 6 ? 'That is about ' + cm(room) + ' more room than a close-fitting ' + size + '.' : 'That is close to the body for a ' + size + '.');
    } else if (m.waist) {
      text = 'In size ' + size + ' the waist measures ' + cm(m.waist[i]) + ' and stretches to about ' + cm(m.waist[i] + STRETCH) + (m.inseam ? ', with a ' + cm(m.inseam[i]) + ' inseam' : '') + '.';
    }
    if (text) { measure.textContent = text; measure.hidden = false; }
    if (you && complete(a)) {
      var r = recommend(chart, a);
      you.textContent = 'Your size in this piece: ' + chart.sizes[r.pick] + (r.verdict === 'between' ? ' (between ' + chart.sizes[Math.min(r.pick, r.other)] + ' and ' + chart.sizes[Math.max(r.pick, r.other)] + ')' : '') + ', from your size finder answers.';
      you.hidden = false;
    }
  }
  function start() {
    var key = guideKey();
    $$('[data-pi-guide]').forEach(function (box) {
      if (key) buildGuide(box); else box.parentNode.removeChild(box);
    });
    var a = load(), chart = complete(a) ? chartFor() : null;
    if (chart) setLabel(chart.sizes[recommend(chart, a).pick]);
    paintCutNote(chart || chartFor(), a);
  }
  document.addEventListener('click', function (e) {
    var fit = e.target.closest('[data-pi-fit]');
    var guide = e.target.closest('[data-pi-measure]');
    if (fit) { e.preventDefault(); e.stopPropagation(); openFit(); }
    if (guide) { e.preventDefault(); e.stopPropagation(); openGuide(); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
